import { BomItemPointer } from 'model/Project/BomItemPointer'
import { BomItemType } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export function bomItemDrawingNumberSelector(bomItemPointer: BomItemPointer) {
  return function (state: RootAppState): string {
    if (!bomItemPointer || !bomItemPointer.id) return null

    const bomItem = bomItemSelector(state, bomItemPointer)

    if (!bomItem) {
      return ''
    }

    switch (bomItem?.type) {
      case BomItemType.partType:
      case BomItemType.partInstance:
      case BomItemType.assemblyType:
      case BomItemType.assemblyInstance:
        return bomItem.drawingNumber
      default:
        console.warn(
          'Unsupported BOM item type for drawing number retrieval:',
          bomItem.type,
        )
        return ''
    }
  }
}
